import React from "react";
import { Checkbox } from "@familyzone/component-library";
import { Flex } from "@chakra-ui/react";

import CriteriaPrinter from "../../modules/CriteriaPrinter";
import FlexibleTable from "../../modules/FlexibleTable";
import TableCentricPage from "../../modules/TableCentricPage";
import TableCentricPageButton from "../../modules/TableCentricPageButton";
import Separator from "../../modules/Separator";

import Api from "../../utils/Api";
import TableLeftPanel from "../../utils/TableLeftPanel";

import EditButton from "../../modules/EditButton";
import DeleteButton from "../../modules/DeleteButton";
import PriorityQosModal from "./PriorityQosModal";
class AddEditRule extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rule: this.props.rule,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.rule !== prevState.rule) {
      return { rule: nextProps.rule };
    } else return null;
  }

  handleHide = () => {
    this.props.handleClose();
  };

  handle_ChangeName = (name) => {
    const rule = this.state.rule;
    rule.comment = name;
    this.setState({ rule: rule });
  };

  handle_SourceCriteriaChanged = (criteria) => {
    const rule = this.state.rule;
    rule.source_criteria = criteria;
    this.setState({ rule: rule });
  };

  handle_DestinationCriteriaChanged = (criteria) => {
    const rule = this.state.rule;
    rule.destination_criteria = criteria;
    this.setState({ rule: rule });
  };

  handle_ChangeDcspValue = (value) => {
    const rule = this.state.rule;
    rule.dscp_value = value;
    this.setState({ rule: rule });
  };

  handle_Submit = () => {
    this.props.handleSave(this.state.rule);
    this.handleHide();
  };

  render() {
    if (this.props.visible) {
      return (
        <PriorityQosModal
          handleHide={this.handleHide}
          isOpen={this.props.visible}
          saveSelection={this.handle_Submit}
          selectedDestinationCriteria={this.state.rule.destination_criteria}
          selectedSourceCriteria={this.state.rule.source_criteria}
          updateParentSourceState={this.handle_SourceCriteriaChanged}
          updateParentPriorityState={this.handle_ChangeDcspValue}
          updateParentDestinationState={this.handle_DestinationCriteriaChanged}
          updateParentNameState={this.handle_ChangeName}
          rule={this.state.rule}
        />
      );
    }

    return <div />;
  }
}

export default class PriorityQos extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rules: [],
      visible__add_group: false,
      editing__permission: undefined,
      loaded: false,
    };
  }

  handle_load = () => {
    let self = this;
    self.setState({
      loaded: false,
    });

    Api.get("/edgewize/ajax/qos/priority", function (result) {
      self.setState({
        rules: result["data"],
        loaded: true,
      });
    });
  };

  componentDidMount() {
    this.handle_load();
  }

  handler__clickAdd = () => {
    let self = this;
    Api.put("/edgewize/ajax/qos/priority", {}, function (result) {
      self.handle_load();
    });
  };

  handler__clickCloseAdd = () => {
    this.setState({
      visible__add_permission: false,
    });
  };

  render__buttons = () => {
    return <TableCentricPageButton title="Add Rule" onClickHandler={this.handler__clickAdd} />;
  };

  handle_Delete = (row) => {
    let self = this;
    Api.delete("/edgewize/ajax/qos/priority", { id: row["id"] }, function (result) {
      self.handle_load();
    });
  };

  handle__SaveRule = (rule) => {
    let self = this;
    Api.post("/edgewize/ajax/qos/priority", rule, function (result) {
      self.handle_load();
    });
  };

  handle_toggleRule = (row) => {
    row["enabled"] = !row["enabled"];

    let self = this;
    Api.post("/edgewize/ajax/qos/priority", row, function (result) {
      self.handle_load();
    });
  };

  handle_Edit = (row) => {
    this.setState({
      editing__permission: row,
      visible__add_permission: true,
    });
  };

  render__content = () => {
    let self = this;
    let columns = [
      {
        title: "Enabled",
        data: function (row) {
          return (
            <Flex alignItems="center">
              <Checkbox
                name={`enabled-${row.id}`}
                isChecked={row["enabled"]}
                onChange={() => self.handle_toggleRule(row)}
                aria-label="Enabled"
              />
            </Flex>
          );
        },
        onclick: undefined,
      },
      {
        title: "Name",
        data: function (row) {
          return row["comment"];
        },
        search: FlexibleTable.search__single_string_field("comment"),
        onclick: undefined,
      },
      {
        title: "Source",
        data: function (row) {
          return <CriteriaPrinter criteria={row["source_criteria"]} />;
        },
        search: FlexibleTable.search__criteria_printer("source_criteria"),
        onclick: undefined,
      },
      {
        title: "Destination",
        data: function (row) {
          return <CriteriaPrinter criteria={row["destination_criteria"]} />;
        },
        search: FlexibleTable.search__criteria_printer("destination_criteria"),
        onclick: undefined,
      },
      {
        title: "Priority",
        data: function (row) {
          return row["dscp_value"];
        },
        search: FlexibleTable.search__single_string_field("dscp_value"),
        onclick: undefined,
      },
      {
        title: "Operations",
        data: function (row) {
          return (
            <div>
              <EditButton onClick={() => self.handle_Edit(row)} />
              <Separator />
              <DeleteButton onClick={() => self.handle_Delete(row)} />
            </div>
          );
        },
        onclick: undefined,
      },
    ];

    return <FlexibleTable columns={columns} data={this.state.rules} loaded={this.state.loaded} />;
  };

  render() {
    return (
      <TableLeftPanel>
        <AddEditRule
          visible={this.state.visible__add_permission}
          handleSave={this.handle__SaveRule}
          handleClose={this.handler__clickCloseAdd}
          rule={this.state.editing__permission}
        ></AddEditRule>

        <TableCentricPage icon="fa fa-filter" title="Priority" buttons={this.render__buttons()} content={this.render__content()} />
      </TableLeftPanel>
    );
  }
}
